import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

import { addEventListener, removeEventListener } from '../../../../utils/dom';
import './modal.scss';
type styleObj = {
  [key: string]: string;
};

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  children: JSX.Element;
  customClass?: string;
  className?: string,
  customOuterClass?: string,
  id?: string;
  extraStyles?:styleObj;
}

export const Modal = ({ isOpen, onClose, children, customClass, className, id, customOuterClass,extraStyles }: ModalProps) => {
  const outsideRef = useRef(null);
  useEffect(() => {
    addEventListener(null,'keydown', handleKeyDown);
    return () => {
      removeEventListener(null,'keydown', handleKeyDown);
    };
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleKeyDown = (event: any) => {
    if (event.code === "Escape" && isOpen) {
      onClose();
    }
  };

  const handleCloseOnOverlay = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (e.target === outsideRef.current) {
      onClose();
    }
  }

  const useDisableBodyScroll = (open) => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  };

  const modalPortal = (<>
    <div className="mfp-bg mfp-fade mfp-ready"></div>
    <div className={`mfp-wrap mfp-fade mfp-ready ${className}`} style={extraStyles}>
      <div data-testid='mfp-wrapper' className="mfp-container mfp-s-ready mfp-inline-holder" ref={outsideRef}
        onClick={handleCloseOnOverlay}>
        <div className={`mfp-content ${customOuterClass}`}>
        <div id={id} className={`mfp-content__inner ${customClass}`} >
            {children}
          </div>
        </div>
      </div>
    </div>
  </>);
  useDisableBodyScroll(isOpen);
  return isOpen ? createPortal(modalPortal, document.body) : null;
};
